import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "../../context/I18nContext";
import Messages from "../../pages/Messages";
import useUnreadMessages from "../../utils/useUnreadMessages";
import "./ChatDock.css";

// Floating chat button (bottom corner) that opens the messages in a small box,
// for teachers and parents. Hidden on the full messages page.
export default function ChatDock() {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { unread, enabled } = useUnreadMessages(location.pathname);
  const onMessagesPage = location.pathname.startsWith("/messages");

  useEffect(() => {
    if (onMessagesPage) setOpen(false);
  }, [onMessagesPage]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  if (!enabled || onMessagesPage) return null;

  return (
    <div className={`chat-dock${open ? " is-open" : ""}`}>
      {open ? (
        <div
          className="chat-dock__panel"
          role="dialog"
          aria-label={t("messages.title")}
        >
          <Messages docked onClose={() => setOpen(false)} />
        </div>
      ) : null}

      <button
        type="button"
        className="chat-dock__launcher"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={open ? t("messages.close") : t("messages.openChat")}
        title={open ? t("messages.close") : t("messages.openChat")}
      >
        <i
          className={open ? "fa-solid fa-xmark" : "fa-solid fa-comment-dots"}
          aria-hidden="true"
        />
        {!open && unread > 0 ? (
          <span className="chat-dock__badge">{unread > 99 ? "99+" : unread}</span>
        ) : null}
      </button>
    </div>
  );
}
